import { getDevice } from './util'

const closePopover = () => {
  const popover = document.querySelectorAll('.afd-share__options');
  popover.forEach(item => {
    !item.classList.contains('afd-hide') && item.classList.add('afd-hide')
    item.addEventListener("click", e => e.stopImmediatePropagation())
  });
}

const togglePopover = button => {
  if (navigator.share && button.dataset.type == 'share' && getDevice() != 'desktop') {
    navigator.share({
      title: document.title,
      url: window.location.href
    })
      .catch(console.error);
  } else {
    const popover = button.nextElementSibling;
    popover.classList.toggle('afd-hide');
  }
}

// Toogle/Close popover clicking on body/button
export const popover = () => {
  const togglePopoverBtns = document.querySelectorAll(".js-toggle-popover");
  const close = document.querySelectorAll(".afd-share__options .js-popover-close");
  const body = document.querySelector("body");

  togglePopoverBtns.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      togglePopover(button);
    });
  });

  close.forEach(closeBtn => closeBtn.addEventListener("click", closePopover))
  body.addEventListener("click", closePopover)
}
